/** Deconstructs version string eg. 26.02.0.24812+d966bd6849 into {year, month, patch, build, commit} */
export const deconstructVersion = (version: string) => {
    const match = version.match(/(\d{2})\.(\d{2})\.(\d+)\.(\d+)\+([a-f0-9]+)/)
    if (!match) throw new Error(`Invalid version string: ${version}`)
    const [, year, month, patch, build, commit] = match
    return { year, month, patch, build, commit }
}